import { FormatterAction } from "./types";

export const FORMATTER_CHANGE_DATE = "CHANGE DATE";
export const FORMATTER_CHANGE_DATE_TIME = "CHANGE DATETIME";

export const changeDateFormat = (payload: string): FormatterAction => {
  return {
    type: FORMATTER_CHANGE_DATE,
    payload,
  };
};

export const changeDateTimeFormat = (payload: string): FormatterAction => {
  return {
    type: FORMATTER_CHANGE_DATE_TIME,
    payload,
  };
};
